import { values } from "lodash";
import { createSelector } from "reselect";

import { dateSort } from "helpers/sort";

import { selectHasLiveChatIntegration } from "../integrations";
import { IWithLicensesState } from "../license";
import { IEntityCollectionState } from "../reducer";

import { IContactForm } from "./interfaces";

export interface IWithContactFormsState {
  entities: {
    contactForms: IEntityCollectionState<IContactForm>;
  };
}

export function selectContactForms(state: IWithContactFormsState): Record<string, IContactForm> {
  return state.entities.contactForms;
}

export const selectHasContactFormsManuallyCreated = createSelector(
  selectContactFormsCount,
  contactForms => contactForms > 0
);

export const selectHasDefaultWidgetContactFormAdded = createSelector(
  selectHasLiveChatIntegration,
  hasIntegration => hasIntegration
);

export function selectContactFormsCount(state: IWithContactFormsState): number {
  return Object.keys(state.entities.contactForms).length;
}

export function selectContactFormsSorted(state: IWithContactFormsState & IWithLicensesState): IContactForm[] {
  return values(selectContactForms(state)).sort((form1, form2) => {
    if (!form1.updatedAt || !form2.updatedAt) {
      return 0;
    }
    return dateSort(new Date(form1.updatedAt), new Date(form2.updatedAt), true);
  });
}
